import React from 'react';
import { Modal,ModalHeader,ModalBody,Row,Col,FormGroup,Input,FormFeedback,Label,ModalFooter,Button} from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalPatientMicro = (props) => {

    const { modalPatient,tooglePatient,handleInformationPatient,savePatient,loadingPatientMicro, errorsPatient } = props;
    
    const footer = (
        <div className="patient-modal-footer">

            <Button
                color="light"
                size="sm"
                onClick={tooglePatient}
                disabled={loadingPatientMicro}
                className="btn-cancel-patient"
            >
                <i className="fa fa-times mr-2"></i>
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                onClick={savePatient}
                disabled={loadingPatientMicro}
                className={`btn-save-patient ${loadingPatientMicro ? "progress-bar-animated progress-bar-striped" : ""}`}
            >
                {
                    loadingPatientMicro ? (
                        <>
                            <i className="fa fa-spinner fa-spin mr-2"></i>
                            Guardando...
                        </>
                    ) : (
                        <>
                            <i className="fa fa-plus mr-2"></i>
                            Crear Cliente
                        </>
                    )
                }
            </Button>

        </div>
    );

    return (
        <Dialog 
            header="Crear Cliente" 
            visible={modalPatient} 
            onHide={tooglePatient} 
            closable 
            modal 
            blockScroll 
            className='large-dialog'
            footer={footer}
        >
            <div className="form-section">
                <Col md="12" className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="section-title">
                        <i className="pi pi-folder-open"></i>
                        Información General
                    </h6>
                </Col>
                 <Row>
                    <Col sm="4" md="4" lg="4">
                        <FormGroup>
                            <Label className="label-admision">Nombres <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Input type="text" name="name"  onChange={e => handleInformationPatient(e, 'name')} invalid={errorsPatient.name} className="input-admision" />                            
                            <FormFeedback> El nombre es obligatorio.</FormFeedback>
                        </FormGroup>
                    </Col>

                    <Col sm="4" md="4" lg="4">
                        <FormGroup>
                            <Label className="label-admision">Apellido paterno <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Input type="text" name='paternal_surname' onChange={e => handleInformationPatient(e, 'paternal_surname')} invalid={errorsPatient.paternal_surname} className="input-admision" />
                            <FormFeedback>El apellido paterno es obligatorio.</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col sm="4" md="4" lg="4" >
                        <FormGroup>
                            <Label className="label-admision">Apellido materno </Label>
                            <Input type="text" name='maternal_surname' onChange={e => handleInformationPatient(e, 'maternal_surname')} className="input-admision" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm="4" md="4" lg="4">
                        <FormGroup>
                            <Label className='label-admision'>Género<span  className='f-16' style={{color: "#0079C7"}}>*</span></Label>
                            <Input
                                    type="select"
                                    name="id_gender"
                                    invalid={errorsPatient.id_gender}
                                    onChange={(e) => {
                                        handleInformationPatient(e, "id_gender");

                                        if (e.target.value !== "0") {
                                            e.target.options[0].disabled = true;
                                        }
                                    }}
                                    className="input-admision"
                                >
                                <option value={0}>Selecciona una opción</option>
                                <option value={1}>Femenino</option>
                                <option value={2}>Masculino</option>
                            </Input>
                            <FormFeedback>Selecciona una opción</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col sm="4" md="4" lg="4">
                        <FormGroup>
                            <Label className='label-admision'>Teléfono</Label>
                            <Input type='tel' name='phone' invalid={errorsPatient.phone} onChange={e => handleInformationPatient(e, 'phone')} className="input-admision"/>
                            {/* <FormFeedback>Completa este campo</FormFeedback> */}
                        </FormGroup>
                    </Col>
                    <Col sm="4" md="4" lg="4">
                        <FormGroup>
                            <Label className='label-admision'>Correo</Label>
                            <Input type='tel' name='email' invalid={errorsPatient.email_patient}  onChange={e => handleInformationPatient(e, 'email_patient')} className="input-admision"/>
                            {/* <FormFeedback>Ingresa un correo valido</FormFeedback> */}
                    </FormGroup>
                    </Col>
                </Row>

            </div>
          
        </Dialog>
    )
}